import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { StudentClassType } from "../../../types/Student";
import { get } from "../../../utils/axios-config";
import { STUDENT_CLASSES } from "../../../utils/constants";

export const getStudentsFromClass = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject } : {}),

    });
    const url = `${STUDENT_CLASSES}?${queryParams.toString()}`;
    return await get<PagedResultsType<StudentClassType>>(url)
};